import { useQuery } from "@tanstack/react-query";
import { decideNextLearningAction } from "@/lib/learning-engine/decideNextLearningAction";
import { useAuth } from "@/hooks/useAuth";

/**
 * React Query wrapper around the canonical governed decision path
 * (`engine_decide`), which stamps policy version, diagnosis, objective and
 * modality and falls back safely to the plain route resolver.
 * Keyed on user so switching accounts refetches. Never returns undefined
 * once loaded — always a decision or the safe-locked fallback.
 */
export function useNextLearningAction() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["heirwise-adaptive-learning-engine", "next-action", user?.id ?? "anon"],
    queryFn: decideNextLearningAction,
    enabled: !!user,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
  });
}